export type AdhocRoute =
  | { kind: "byUser"; userJid: string; narrowToRoomJid?: string }
  | { kind: "byMuc"; mucJid: string }
  | { kind: "all" }

export function pickAdhocRoute(args: {
  driverJid?: string
  roomJid?: string
}): AdhocRoute {
  const driver = args.driverJid?.trim() || undefined
  const room = args.roomJid?.trim() || undefined

  if (driver) {
    return room
      ? { kind: "byUser", userJid: driver, narrowToRoomJid: room }
      : { kind: "byUser", userJid: driver }
  }
  if (room) {
    return { kind: "byMuc", mucJid: room }
  }
  return { kind: "all" }
}
